<template>
  <div id="cards">
    <div
      class="card-item"
      v-for="card in cards"
      :key="card.title"
    >
      <div class="card-header">
        <div class="card-header-left">人口流动</div>
        <div class="card-header-right">{{ card.month }}</div>
      </div>
      <div class="card-footer">
        <div class="card-footer-item">
          <div class="footer-title">迁入</div>
          <div class="footer-detail">
            <span class="in">{{card.in}}</span>
            <span class="unit">人</span>
          </div>

        </div>
        <div class="card-footer-item">
          <div class="footer-title">迁出</div>
          <div class="footer-detail">
            <span class="out">{{card.out}}</span>
            <span class="unit">人</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRandomNumber } from '@/utils/common'

export default {
  name: 'Cards',
  data () {
    return {
      cards: [
        {
          month: '2023年8月',
          in: getRandomNumber(1000, 2000),
          out: getRandomNumber(1200, 2400)
        },
        {
          month: '2023年9月',
          in: getRandomNumber(1000, 2000),
          out: getRandomNumber(1200, 2400)
        },
        {
          month: '2023年10月',
          in: getRandomNumber(1000, 2000),
          out: getRandomNumber(1200, 2400)
        },
        {
          month: '2023年11月',
          in: getRandomNumber(1000, 2000),
          out: getRandomNumber(1200, 2400)
        },
        {
          month: '2023年12月',
          in: getRandomNumber(1000, 2000),
          out: getRandomNumber(1200, 2400)
        }
      ]
    }
  }
}
</script>

<style lang="less">
#cards {
  display: flex;
  justify-content: space-between;
  height: 45%;

  .card-item {
    background-color: rgba(6, 30, 93, 0.5);
    border-top: 2px solid rgba(1, 153, 209, .5);
    width: 19%;
    display: flex;
    flex-direction: column;
  }

  .card-header {
    display: flex;
    height: 20%;
    align-items: center;
    justify-content: space-between;

    .card-header-left {
      font-size: 18px;
      font-weight: bold;
      padding-left: 20px;
    }

    .card-header-right {
      padding-right: 20px;
      font-size: 18px;
      color: #03d3ec;
    }
  }

  .card-footer {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .card-footer-item {
    padding: 5px 10px 0px 10px;
    box-sizing: border-box;
    width: 40%;
    background-color: rgba(6, 30, 93, 0.7);
    border-radius: 3px;

    .footer-title {
      font-size: 15px;
      margin-bottom: 5px;
    }

    .footer-detail {
      color: #fff;
      //display: flex;
      //align-items: center;

      .in {
        color: #03d3ec;
        font-size: 32px;
      }

      .out {
        color: #ff5b5b;
        font-size: 32px;
      }

      .dv-digital-flop {
        margin-right: 5px;
      }
    }
  }
}
</style>
